import { useEffect } from "react";
import { ifDevMessage } from "../devMessage/devMessage";
export var deprecatedComponentMessage = function(param) {
    var componentName = param.componentName, date = param.date, upgradeURL = param.upgradeURL;
    ifDevMessage("[DEPRECATION] <".concat(componentName, " />\n") + "Carina <".concat(componentName, " /> is deprecated and will be removed at the end of ").concat(date, "! ") + "Check out the link below for upgrade guidance. \n".concat(upgradeURL));
};
export var deprecatedPropValueMessage = function(param) {
    var componentName = param.componentName, propName = param.propName, propValue = param.propValue, date = param.date, upgradeURL = param.upgradeURL;
    ifDevMessage("[PROP VALUE DEPRECATION]: <".concat(componentName, " ").concat(propName, "='").concat(propValue, "' />\n") + "Value '".concat(propValue, "' for property '").concat(propName, "' is deprecated and will be removed at the end of ").concat(date, "! ").concat(upgradeURL ? "Check out the link below for upgrade guidance.\n".concat(upgradeURL) : ''));
};
export var useDeprecatedComponentMessage = function(messageOptions) {
    useEffect(function() {
        deprecatedComponentMessage(messageOptions);
    }, []);
};
